import { Launch } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import * as styles from './HelpSection.styles';

export const HelpSection = () => {
  return (
    <Card sx={styles.card}>
      <CardContent sx={styles.cardContent}>
        <Box sx={styles.contentContainer}>
          <Box
            component="img"
            src="/vector-2.svg"
            alt="Help icon"
            sx={styles.iconImage}
          />

          <Typography variant="h6" color="text.primary" sx={styles.titleTypography}>
            Need help getting started?
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={styles.descriptionTypography}>
            Check out our documentation or reach out to us directly.
          </Typography>

          <Box sx={styles.buttonsContainer}>
            <Button variant="outlined" sx={styles.contactButton}>
              Contact support
            </Button>

            <Button
              variant="contained"
              color="primary"
              endIcon={<Launch />}
              sx={styles.docsButton}
            >
              View docs
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
